import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const settingInit = {
  settings: {},
  isLoadingSettings: false,
};

function settingsReducer(draft, { type, payload }) {
  switch (type) {
    case "setSettings": {
      payload.Settings.forEach(setting => draft.settings[[setting.id]] = setting)
      break;
    }
    case "setIsLoadingSettings": {
      draft.isLoadingSettings = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [SettingContext, SettingDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function SettingProvider({ children }) {
  const [settingStore, dispatch] = useImmerReducer(settingsReducer, settingInit);

  return (
    <SettingContext.Provider value={settingStore}>
      <SettingDispatchContext.Provider value={dispatch}>
        {children}
      </SettingDispatchContext.Provider>
    </SettingContext.Provider>
  );
}

export function useSettingStore() {
  return useContext(SettingContext);
}

export function useSettingDispatch() {
  return useContext(SettingDispatchContext);
}